<template>
  <div>
    <div class='dialog-body'>
      <el-input class='loginInput' v-model='phone' placeholder='请输入手机号码'></el-input>
      <el-input class='loginInput' v-model='verify_code' placeholder='短信验证码'>
        <el-button slot='append' v-show='showTime' @click='send()'>发送验证码</el-button>
        <div class='resendstr' slot='append' v-show='!showTime'>重发({{ sendTime }})</div>
      </el-input>
      <el-button class='loginInput' type='primary' @click='login()'>立即登录</el-button>
    </div>
    <span slot='footer' class='dialog-footer'>
      <div class='loginTips'>如果您的手机尚未注册网站账号，将使用该手机号码注册账号。</div>
    </span>
  </div>
</template>

<script>
export default {
  name: 'mobileLayer',
  props: {
    appScanShow: {
      type: Boolean,
      default: false
    },
    phone: {
      type: Number,
      default: null
    },
    verify_code: {
      type: String,
      default: null
    },
    showTime: {
      // 通过v-show控制显示'获取按钮'还是'倒计时'
      type: Boolean,
      default: true
    },
    sendTime: {
      // 倒计时计数器
      type: Number,
      default: null
    },
    timer: {
      type: Number,
      default: null
    }
  }
}
</script>

<style scoped>
  .resendstr {
    width: 71px;
  }
  .loginInput {
    width: 430px;
    margin-bottom: 10px;
  }
  .loginTips {
    font-size: 12px;
    color: #B4B5BF;
  }
  .el-dialog__body {
    transform: translate3d(0, 0, 0);
    overflow: auto;
    height: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/components/login/popup/mobileLoginLayer.vue